const GET_PROJECTS_STATS = 'infra/GET_PROJECTS_STATS';
const GET_PROJECTS_STATS_SUCCESS = 'infra/GET_PROJECTS_STATS_SUCCESS';
const GET_PROJECTS_STATS_ERROR = 'infra/GET_PROJECTS_STATS_ERROR';
const SET_SELECTED_WARD = 'infra/SET_SELECTED_WARD';

export default {
  GET_PROJECTS_STATS,
  GET_PROJECTS_STATS_SUCCESS,
  GET_PROJECTS_STATS_ERROR,
  SET_SELECTED_WARD,
};



// WEBPACK FOOTER //
// ./src/infraMonitor/projects-stats/types.js